var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7725 13.5264V18.7953H24.0945C23.773 20.4897 22.8081 21.9245 21.361 22.8892L25.7765 26.3153C28.3491 23.9406 29.8333 20.4527 29.8333 16.3094C29.8333 15.3447 29.7468 14.417 29.5859 13.5265L16.7725 13.5264Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14295 18.5898L8.14709 19.3522L4.62207 22.0979C6.86073 26.5381 11.449 29.6055 16.7674 29.6055C20.4406 29.6055 23.5203 28.3934 25.7714 26.3155L21.3559 22.8895C20.1438 23.7058 18.5978 24.2006 16.7674 24.2006C13.23 24.2006 10.2246 21.8135 9.14851 18.5977L9.14295 18.5898Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62635 9.90332C3.69877 11.7338 3.16699 13.7993 3.16699 16.0008C3.16699 18.2023 3.69877 20.2679 4.62635 22.0983C4.62635 22.1106 9.15322 18.5857 9.15322 18.5857C8.88112 17.7694 8.72029 16.9037 8.72029 16.0007C8.72029 15.0977 8.88112 14.2319 9.15322 13.4156L4.62635 9.90332Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7676 7.81185C18.7713 7.81185 20.5523 8.50446 21.9747 9.84025L25.8707 5.94428C23.5083 3.74276 20.4411 2.39453 16.7676 2.39453C11.4493 2.39453 6.86073 5.4495 4.62207 9.90211L9.14881 13.4147C10.2248 10.1989 13.2303 7.81185 16.7676 7.81185Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.ebf6db6d63614835cfaef4391f111161.svg";
export { ForwardRef as ReactComponent };